import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { makeStyles } from 'tss-react/mui';
import { I as IconMap2 } from './IconMap2-eee549e3.js';
import { a as TextEllipsisTooltip } from './TextEllipsisTooltip-dd731448.js';
import { B as BoxedImg } from './BoxedImg-fedbb73b.js';
import '@mui/material/SvgIcon';
import '@mui/material';
import './theme-f4aeefe2.js';
import 'react';
import '@mui/material/Skeleton';
import '@mui/material/Box';
import '@mui/material/Typography';
import '@mui/material/Menu';
import '@mui/material/Divider';
import '@mui/material/Grid';
import '@mui/material/Container';
import '@mui/material/Collapse';
import '@mui/material/Slide';
import '@mui/material/Modal';
import '@mui/material/IconButton';
import '@mui/material/CircularProgress';
import '@mui/material/MenuItem';
import '@mui/material/styles';
import '@mui/material/CssBaseline';
import '@mui/material/Paper';
import '@mui/material/Avatar';

const useMediaInfoBlockStyles = makeStyles()((theme, { disabled }) => ({
    infoBox: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1),
        borderRadius: theme.shape.borderRadiusS,
        color: theme.palette.primary.main,
        gap: theme.spacing(2),
    },
    textContainer: Object.assign({ flex: 1, minWidth: 0 }, (disabled && {
        opacity: 0.6,
    })),
    subText: {
        display: 'flex',
        minWidth: 0,
        alignItems: 'center',
        gap: theme.spacing(1),
        textTransform: 'uppercase',
        color: theme.palette.primaryScale[700],
        whiteSpace: 'nowrap',
    },
    iconContainer: {
        display: 'flex',
        opacity: disabled ? 0.6 : 1,
    },
}));

const MediaInfoBlock = (_a) => {
    var { className, Title, Subtitle, Media, Icon, disabled, onClick } = _a, rest = __rest(_a, ["className", "Title", "Subtitle", "Media", "Icon", "disabled", "onClick"]);
    const { classes, cx } = useMediaInfoBlockStyles({ disabled });
    return (jsxs("div", Object.assign({ className: cx(classes.infoBox, className), onClick: disabled ? undefined : onClick }, rest, { children: [!!Media ? Media : jsx(IconMap2, {}), jsxs("div", { className: classes.textContainer, children: [Title, jsx("div", { className: classes.subText, children: Subtitle })] }), jsx("div", { className: classes.iconContainer, children: !!Icon && Icon })] })));
};
const MediaInfoBlockTitle = (_a) => {
    var { text } = _a, rest = __rest(_a, ["text"]);
    return (jsx(TextEllipsisTooltip, Object.assign({ text: text }, rest)));
};
const MediaInfoBlockSubtitle = (_a) => {
    var { text, typographyProps } = _a, rest = __rest(_a, ["text", "typographyProps"]);
    return (jsx(TextEllipsisTooltip, Object.assign({ typographyProps: Object.assign({ variant: 'subcaption' }, typographyProps), text: text }, rest)));
};
const MediaInfoBlockImage = (_a) => {
    var { size = 'medium', src, imgPosition } = _a, rest = __rest(_a, ["size", "src", "imgPosition"]);
    return (jsx(BoxedImg, Object.assign({ size: size, src: src, imgPosition: imgPosition !== null && imgPosition !== void 0 ? imgPosition : 'top' }, rest)));
};
MediaInfoBlock.Title = MediaInfoBlockTitle;
MediaInfoBlock.Subtitle = MediaInfoBlockSubtitle;
MediaInfoBlock.Image = MediaInfoBlockImage;

export { MediaInfoBlock };
//# sourceMappingURL=MediaInfoBlock.es.js.map
